import { useResponsive } from '../../hooks/useResponsive';

/**
 * ResponsiveGrid: Auto-responsive grid that adjusts columns based on screen size
 *
 * @param {React.ReactNode} children - Grid items
 * @param {Object} config - { mobileCols, tabletCols, desktopCols, gap, minItemWidth }
 */
export default function ResponsiveGrid({ children, config = {} }) {
  const { isMobile, isTablet } = useResponsive();
  const {
    mobileCols = 1,
    tabletCols = 2,
    desktopCols = 3,
    gap = 16,
    minItemWidth = 240,
  } = config;

  const cols = isMobile ? mobileCols : isTablet ? tabletCols : desktopCols;
  const itemWidth = `calc((100% - ${gap * (cols - 1)}px) / ${cols})`;

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: `${gap}px`,
        width: '100%',
      }}
    >
      {Array.isArray(children)
        ? children.map((child, idx) => (
            <div
              key={idx}
              style={{
                width: itemWidth,
                minWidth: minItemWidth,
                boxSizing: 'border-box',
              }}
            >
              {child}
            </div>
          ))
        : children}
    </div>
  );
}
